import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { getGiftFinderConfig } from './giftFinderSettings';
import GiftFinderPage from './GiftFinderPage';

export default function GiftFinderRoute() {
  const { settings, status } = useSiteSettings();
  const config = getGiftFinderConfig(settings?.store_copy);

  if (status === 'loading') {
    return (
      <div className="store-page gift-finder-page">
        <div className="container store-page__container py-5 text-center text-muted">Loading…</div>
      </div>
    );
  }

  if (!config.enabled) {
    return <Navigate to="/shop" replace />;
  }

  return <GiftFinderPage config={config} />;
}
